export const getTranslation = (i18n, key) => {
  const keys = key.split(".");

  // Get translations from i18n store (which includes remote translations loaded by i18n.js)
  let data = i18n.store.data?.[i18n.language]?.translation;

  for (const k of keys) {
    if (data && data[k] !== undefined) {
      data = data[k];
    } else {
      return key;
    }
  }

  return data;
};
